import { TextLink } from 'baby-design'
import { absoluteUrl, reservationsPath } from 'lib/urls'
import css from './InCartLink.styles.scss'

interface InCartLinkProps {
  quantity: number
}

const InCartLink = ({ quantity }: InCartLinkProps) => {
  return (
    <div className={css.InCartLink}>
      <TextLink variant="eggplant" href={absoluteUrl(reservationsPath)}>
        {quantity} in cart
      </TextLink>
    </div>
  )
}

export default InCartLink
